import { LargeClassCodeComboBoxModel } from '../large-class-code-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 大分類情報リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetLargeClassListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetLargeClassListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: LargeClassCodeComboBoxModel;
  private orderCode: string = <string>'';
  private classCode: string = <string>'';
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetLargeClassListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode,
        ClassCode: this.classCode
      }
    });;
  }

  /**
   * API呼び出し
   *
   * @param {LargeClassCodeComboBoxModel} model
   * @param {string} orderCode
   * @param {string} classCode
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetLargeClassListService
   */
  execute(model: LargeClassCodeComboBoxModel, orderCode: string, classCode: string, successFunc: Function = null) {
    this.model = model;
    this.orderCode = orderCode;
    this.classCode = classCode;
    this.successFunc = successFunc;
    this.send('KYMW02getLargeClassList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetLargeClassListService
   */
  success(data: any) {
    this.model.updateLargeClassList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
